import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getEntityById, recordHasContractorId } from '../../utils/DataAccessUtils';
import {
	appendWorkOrderNotesForSupplier,
	workOrdersRestCrudThunksForSupplier,
} from '../../thunks/work_orders_thunks';
import { markUserNotificationsReadForSupplier } from '../../thunks/user_notifications_thunks';
import SupplierQuoteDetailDetailsPageWrapper from '../supplier_quote_detail_details_page_wrapper/SupplierQuoteDetailDetailsPageWrapper';
import { getQuoteRestCrudThunksFromPath, isClientQuoteView } from '../quote_utils/QuoteUtils';
import { getSanitisedWorkOrder } from '../../utils/WorkOrderUtils';

class SupplierQuotesDetailDetailsPage extends React.Component<any, any> {
	refreshQuote = () => {
		const { getQuote, match, getWorkOrder, location, userType } = this.props;
		const quoteId = match.params.id;
		getQuote(quoteId);
	};

	componentDidMount() {
		const { getQuote, match, markUserNotificationsRead, quote, location, userType } = this.props;
		const quoteId = match.params.id;
		if (quote && quote.id) {
			markUserNotificationsRead(quoteId);
		} else {
			getQuote(quoteId).then(() => markUserNotificationsRead(quoteId));
		}
	}
	componentDidUpdate(prevProps) {
		const { quote, markUserNotificationsRead } = this.props;
		const { quote: prevQuote } = prevProps;
		if (quote && prevQuote && quote.id !== prevQuote.id) {
			markUserNotificationsRead(quote.id);
		}
	}

	render() {
		const { quote = {}, quoteFetching, quotesUpdating, location, currentUser } = this.props;
		return quoteFetching ? null : (
			<SupplierQuoteDetailDetailsPageWrapper
				quote={quote}
				quotesUpdating={quotesUpdating}
				location={location}
				workOrder={getSanitisedWorkOrder(quote.workOrder, isClientQuoteView(quote, currentUser))}
				refreshQuote={this.refreshQuote}
				showViewQuotePage={false}
				isClientView={isClientQuoteView(quote, currentUser)}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	quoteFetching: state.proposals.fetching,
	quote: getEntityById(ownProps.match.params.id, state.proposals),
	quotesUpdating: state.proposals.updating,
	currentUser: state.session.currentUser,
	match: ownProps.match,
	history: ownProps.history,
	location: ownProps.location,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	appendWorkOrderNotes: (entity) => dispatch(appendWorkOrderNotesForSupplier(entity)),
	getWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForSupplier.readOne(id)),
	getQuote: (id) =>
		dispatch(getQuoteRestCrudThunksFromPath(ownProps.userType, ownProps.location).readOne(id)),
	markUserNotificationsRead: (entityId) =>
		dispatch(markUserNotificationsReadForSupplier('Quote', entityId)),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SupplierQuotesDetailDetailsPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
